import axios, { getData } from 'lib/axios'

// export const getProjectTrackerStaff = async (params = {}) => {
//     const res = await axios.get('/staff-list', { params })
//     return getData(res)
// }

export const getProjectTrackerStaff = async (params = {}) => {
    const res = await axios.get('/staff/all-by-department', { params })
    return getData(res)
}

export const getProjectTrackerProjects = async (params = {}) => {
    const res = await axios.get('/projects', { params })
    return getData(res)
}

export const getMyProjects = async (params = {}) => {
    const res = await axios.get('/my-projects', { params })
    return getData(res)
}

export const createProjectTrackerProject = async (payload) => {
    const res = await axios.post('/projects', payload)
    return getData(res)
}

export const getProjectTrackerProjectById = async (projectId, params = {}) => {
    const res = await axios.get(`/projects/${projectId}`, { params })
    return getData(res)
}

export const updateProjectTrackerProject = async (projectId, payload) => {
    const res = await axios.patch(`/projects/${projectId}`, payload)
    return getData(res)

}

export const completeProjectTrackerProject = async (projectId) => {
    const res = await axios.post(`/projects/${projectId}/complete`)
    return getData(res)
}

export const getProjectTrackerTasks = async (params = {}) => {
    const res = await axios.get('/tasks', { params })
    return getData(res)
}

export const getAllTasks = getProjectTrackerTasks

export const getMyProjectsOnly = async (params = {}) => {
    const res = await axios.get('/my-projects', { params })
    return getData(res)
}

export const getMyTeamMemberProjects = async (params = {}) => {
    const res = await axios.get('/my-projects/team-member', { params })
    return getData(res)
}

export const getMyTasks = async (params = {}) => {
    const res = await axios.get('/my-tasks', { params })
    return getData(res)
}

export const getTask = async (taskId) => {
    const res = await axios.get(`/tasks/${taskId}`)
    return getData(res)
}

export const createTask = async (taskData) => {
    const res = await axios.post('/tasks', taskData)
    return getData(res)
}

export const updateTask = async (taskId, taskData) => {
    const res = await axios.put(`/tasks/${taskId}`, taskData)
    return getData(res)
}

export const deleteTask = async (taskId) => {
    const res = await axios.delete(`/tasks/${taskId}`)
    return getData(res)
}


export const submitTask = async (submitData) => {
    const res = await axios.post('/tasks/submit', submitData)
    return getData(res)
}

export const withdrawTaskSubmission = async (taskId) => {
    const res = await axios.post(`/tasks/${taskId}/withdraw-submission`)
    return getData(res)
}


export const getMyReviews = async (params = {}) => {
    const res = await axios.get('/tasks/my-reviews', { params })
    return getData(res)
}

// get to reviews function (tasks to be reviewed by current user)
export const getToReviews = async (params = {}) => {
    const res = await axios.get('/to-review', { params })
    return getData(res)
}

export const getCompletedToReviews = async (params = {}) => {
    const res = await axios.get('/to-review/completed', { params })
    return getData(res)
}

export const getProjectDeliverables = async (projectId) => {
    const res = await axios.get(`/projects/${projectId}/my-deliverables`)
    return getData(res)
}

// get my deliverables for a specific project (current user only)
export const getMyDeliverables = async (projectId) => {
    const res = await axios.get(`/projects/${projectId}/my-deliverables`)
    return getData(res)
}

// submit review for a task
export const submitReview = async (taskId, reviewData) => {
    const res = await axios.post(`/tasks/${taskId}/review`, reviewData)
    return getData(res)
}

export const scheduleTask = async (taskId, scheduleData) => {
    const res = await axios.patch(`/tasks/${taskId}/schedule`, scheduleData)
    return getData(res)
}

export const updateTaskWorkingPeriod = async (taskId, payload) => {
    const res = await axios.patch(`/tasks/${taskId}/working-period`, payload)
    return getData(res)
}

export const getLeaderboardScores = async (params = {}) => {
    const res = await axios.get('/leaderboard/company', { params })
    return getData(res)
}

export const getLeaderboardPerformanceCard = async (params = {}) => {
    const res = await axios.get('/leaderboard/performance-cards', { params })
    return getData(res)
}
